"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _colors = require("../../../constants/colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var HomeIcon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(HomeIcon, _PureComponent);

  function HomeIcon() {
    _classCallCheck(this, HomeIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(HomeIcon).apply(this, arguments));
  }

  _createClass(HomeIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          solid = _this$props.solid;
      var style = solid ? {
        fill: color,
        enableBackground: 'new 0 0 63 63'
      } : {
        fill: 'none',
        stroke: color,
        strokeWidth: '1.5px'
      };
      return _react2.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 17",
        style: style
      }, _react2.default.createElement("g", {
        id: "prefix__home-24px",
        transform: "translate(-2 -3)"
      }, _react2.default.createElement("path", {
        id: "prefix__Path_1585",
        d: "M12 3L2 12h3v8h6v-6h2v6h6v-8h3zm5 15h-2v-6H9v6H7v-7.8l5-4.5 5 4.5z",
        "data-name": "Path 1585"
      }), _react2.default.createElement("path", {
        id: "prefix__Path_1586",
        d: "M7 10.2V18h2v-6h6v6h2v-7.8l-5-4.5z",
        "data-name": "Path 1586",
        style: {
          opacity: .3
        }
      })));
    }
  }]);

  return HomeIcon;
}(_react.PureComponent);

HomeIcon.defaultProps = {
  color: _colors.fontColorSecondary,
  solid: true
};
exports.default = HomeIcon;